export const languages = {
  English: {
    TEST: 'Test',
    HOME: 'Home',
    OPERATION: 'Operation',
    FUNCTION: 'Function',
    QUEUE: 'Queue',
    SCHOOL: 'School',
    ADMIN: 'Admin',
    REPORT: 'Report',
    CONFIG: 'Config',
    ATTENDANCE: 'Attendance',
    CLASS: 'Class',
    GRADE: 'Grade',
    STUDENT: 'Student',
    TEACHER: 'Teacher',
    ROLE: 'Role',
    USER: 'User',
    CREATE: 'Create',
    REQUEST: 'Request',
    UPDATE: 'Update',
    DETAIL: 'Detail',
    INFO: 'Info',
    LAYOUT: 'Layout',
    SALE: 'Sale',
    ORGANIZE: 'Organize',
    // Component
    IMPORT_DATA: 'Import\u00a0Data',
    EXPORT_DATA: 'Export\u00a0Data',
    DOWNLOAD_TEMPLATE: 'Download\u00a0Template',
    PRODUCT: 'Product',
    BY_NAME: 'By\u00a0Name',
    BY_DATE: 'By\u00a0Date',
    BY_PRICE: 'By\u00a0Price',
    BY_DESCRIPTION: 'By\u00a0Description',
    AVAILABLE: 'Available',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    CLEAR: 'Clear',
    // Sale
    TRANSACTION: 'Transaction',
    RESERVATION: 'Reservation',
    STOCK: 'Stock',
    PROMOTION: 'Promotion',
    BANNER: 'Banner',
    ORDER: 'Order',
    TOTAL_TRANSACTION: 'Total\u00a0Transaction',
    TOTAL_RESERVATION: 'Total\u00a0Reservation',
    TOTAL_STOCK: 'Total\u00a0Stock',
    TOTAL_PROMOTION: 'Total\u00a0Promotion',
    TOTAL_BANNER: 'Total\u00a0Banner',
    CASHING: 'Cashing',
    INVOICE: 'Invoice',
    // Function
    TOTAL_QUEUE: 'Total\u00a0Queue',
    // Organize
    CATEGORY: 'Category',
    BRAND: 'Brand',
    STORE: 'Store',
    FLOOR: 'Floor',
    TOTAL_CATEGORY: 'Total\u00a0Category',
    TOTAL_BRAND: 'Total\u00a0Brand',
    TOTAL_PRODUCT: 'Total\u00a0Product',
    TOTAL_STRUCTURE: 'Total\u00a0Structure',
    TOTAL_FLOOR: 'Total\u00a0Floor',
    // Invoice Form
    PRICE: 'Price',
    QTY: 'Qty',
    ONLY: 'Only',
    DISC: 'Disc',
    TOTAL: 'Total',
    SUBTOTAL: 'Subtotal',
    DISCOUNT: 'Discount',
    TAX: 'Tax',
    VOUCHER: 'Voucher',
    PAYMENT: 'Payment',
    LOAN_PAYMENT: 'Loan\u00a0Payment',
    PROCEED: 'Proceed',
    COMPLETED: 'Completed',
    GENERAL: 'General',
    START_NOW: 'Start\u00a0Now',
    // Table
    DESCRIPTION: 'Description',
    START_AT: 'Start\u00a0At',
    EXPIRE_AT: 'Expire\u00a0At',
    STATUS: 'Status',
    ITEM: 'Item',
    ACTION: 'Action',
    QUANTITY: 'Quantity',
    ICON: 'Icon',
    NAME: 'Name',
    CREATED_BY: 'Created\u00a0By',
    CREATED_AT: 'Created\u00a0At',
    USERNAME: 'Username',
    EMAIL: 'Email',
    COST: 'Cost',
    CURRENCY: 'Currency',
    REMAIN: 'Remain',
    // Admin
    TOTAL_ROLE: 'Total\u00a0Role',
    TOTAL_USER: 'Total\u00a0User',
    TOTAL_PRIVILEGE: 'Total\u00a0Privilege',
    INCOME: 'Income',
    PROFIT: 'Profit',
    CHART: 'Chart',
    // Report
    STAFF: 'Staff',
    SCHOOL_REPORT: 'School\u00a0Report',
    ATTENDANCE_REPORT: 'Attendance\u00a0Report',
    SALE_REPORT: 'Sale\u00a0Report',
    PRODUCT_REPORT: 'Product\u00a0Report',
    STAFF_REPORT: 'Staff\u00a0Report',
    INCOME_CHART: 'Income\u00a0Chart',
    PERFORMANCE_CHART: 'Performance\u00a0Chart',
    PRODUCT_CHART: 'Product\u00a0Chart',
    TOP_PRODUCT: 'Top\u00a0Product',
    // Product Form
    COLOR: 'Color',
    ADD_TO_CART: 'Add\u00a0To\u00a0Cart',
    ADD_TO_QUEUE: 'Add\u00a0To\u00a0Queue',
    ADDED_TO_QUEUE: 'Added\u00a0To\u00a0Queue',
    ADD_PROPERTY: 'Add\u00a0Property',
    CLONE_PROPERTY: 'Clone\u00a0Property',
    // Drawer Form
    UNIT: 'Unit',
    DRAWER: 'Drawer',
    BUY_RATE: 'Buy\u00a0Rate',
    SELL_RATE: 'Sell\u00a0Rate',
    STOP: 'Stop',
    START: 'Start',
    CASH: 'Cash',
    // Payment Form
    RECEIVE_TOTAL: 'Receive\u00a0Total',
    RETURN: 'Return',
    PRINT: 'Print',
    CHECKOUT: 'Checkout',
    CLOSE: 'Close',
    APPROVE: 'Approve',
    APPROVE_ALL: 'Approve\u00a0All',
    TRANSFER: 'Transfer',
    SELL: 'Sell',
    BUY: 'Buy',
    // Homepage
    HOMEPAGE_TITLE: 'Welcome to Our Stationery Store',
    WELCOME_TO: 'Welcome to',
    // Form
    LOGIN: 'Login',
    REGISTER: 'Register',
    FROM: 'From',
    TO: 'To',
    NOTE: 'Note',
    STRUCTURE: 'Structure',
    SIZE: 'Size',
    CUSTOMER: 'Customer',
    ADD: 'Add',
    DISPLAY_NAME: 'Display\u00a0Name',
    FULL_NAME: 'Full\u00a0Name',
    CONTACT: 'Contact',
    DATE_OF_BIRTH: 'Date\u00a0Of\u00a0Birth',
    PROFILE: 'Profile',
    ADDRESS: 'Address',
    EDIT: 'Edit',
    DELETE: 'Delete',
    PRIVILEGE: 'Privilege',
    LOGOUT: 'Logout',
    ATTACHMENT: 'Attachment',
    VIEW_ATTACHMENT: 'View\u00a0Attachment',
    INTEREST: 'Interest',
    PENALTY: 'Penalty',
    DEPOSIT: 'Deposit',
    DURATION: 'Duration',
    LOAN_DURATION: 'Loan\u00a0Duration',
    APPLY_RATE: 'Apply\u00a0Rate',
    DUE_DATE: 'Due\u00a0Date',
    PRINCIPAL_AMOUNT: 'Principal\u00a0Amount',
    PRINCIPAL_BALANCE: 'Principal\u00a0Balance',
    INTEREST_AMOUNT: 'Interest\u00a0Amount',
    TOTAL_AMOUNT: 'Total\u00a0Amount',
    INSTALMENT_DURATION: 'Instalment\u00a0Duration',
    CHANGE_PASSWORD: 'Change\u00a0Password',
    OVERDUE: 'Overdue',
    PREPAYMENT: 'Prepayment',
    PREPAYMENT_PENALTY: 'Prepayment\u00a0Penalty',
    PREPAYMENT_DURATION: 'Prepayment\u00a0Duration',
    OVERDUE_DURATION: 'Overdue\u00a0Duration',
    OVERDUE_PENALTY: 'Overdue\u00a0Penalty',
    SEARCH: 'Search',
    CONFIRM: 'Confirm',
    SETUP: 'Setup',
    CALL: 'Call',
    COMPLETE: 'Complete',
    // Message
    TYPE_TO_SEARCH: 'Type to search...',
    CONFIRM_DELETE: 'Do you want to delete?',
    CONFIRM_DELETE_CUSTOMER: 'Are you sure you want to delete this customer?',
    DESCRIPTION_DELETE: 'After proceed you will not see this item again!',
    DESCRIPTION_DELETE_CUSTOMER: 'This will delete the customer and erase all the data.',
    NO_TRANSACTION: 'No\u00a0Transaction',
    NO_OPTIONS: 'No\u00a0Option',
    EXPIRE_IN: 'Expire\u00a0In',
    EXPIRED: 'Expired',
    TRIAL: 'Trial',
    day: 'day',
    PAGE_NOT_FOUND: 'Page not found',
    PAGE_NOT_FOUND_DESCRIPTION: 'The request destination could not be found on the server',
    NO_PERMISSION: `You don't have permission to access this page`,
    NO_PERMISSION_DESCRIPTION: 'Please go to',
    // Status
    VACANT: 'Vacant',
    OCCUPIED: 'Occupied',
    RESERVED: 'Reserved',
    LOAN: 'Loan',
    // Config
    SENT_AFTER_PAYMENT: 'Sent after payment',
    SENT_AFTER_OPEN_DRAWER: 'Sent after open drawer',
    SENT_AFTER_CLOSE_DRAWER: 'Sent after close drawer',
    REQUEST_LOAN: 'Request\u00a0Loan',
    // Loan Detail
    TOTAL_LOAN: 'Total\u00a0Loan',
    TOTAL_PAID: 'Total\u00a0Paid',
    TOTAL_REMAIN: 'Total\u00a0Remain',
    TOTAL_PENALTY: 'Total\u00a0Penalty',
    DEPOSIT_LOAN: 'Deposit\u00a0Balance',
    GRAND_TOTAL: 'Grand\u00a0Total',
    IN_PROGRESS: 'In\u00a0Progress',
    CLEARED: 'Cleared',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    PENDING: 'Pending',
    PRINCIPLE_AMOUNT: 'Principle Amount',
    PAY_OFF: 'Pay Off',
    PAID_OFF: 'Paid Off',
    TERMINATE: 'Terminate',
    WRITE_OFF: 'Write Off',
    WRITE_OFF_LOAN: 'Write Off Loan',
    WRITTEN_OFF: 'Written Off',
    IN_REVIEW: 'In\u00a0Review',
    PREVIEW: 'Preview',
    LOAN_AMOUNT: 'Loan\u00a0Amount',
    PHONE_NUMBER: 'Phone\u00a0Number',
    SELECT_CUSTOMER: 'Select\u00a0Customer',
    ADD_CUSTOMER: 'Add\u00a0Customer',
    NO_CUSTOMER_DESCRIPTION: 'No customer found. Click below to add new.',
    RECEIPT: 'Receipt',
    CLEAR_PAYMENT: 'Clear Payment',
    CLEAR_PAYMENT_WARNING: 'This action will permanently delete all payment data within the specified date range. Please ensure that you have backed up any necessary information before proceeding.',
    WARNING: 'Warning',
    BACKUP: 'Backup',
    THERMAL_PRINTING: 'Label Printing',
    PRINT_LABEL: 'Print Label',
    PRINT_RECEIPT: 'Print Receipt',
    GROUP_PAYMENT: 'Group Payment',
    TABLE: 'Table',
    TYPE: 'Type',
    PAYMENT_ADD_CASH: 'Add Cash',
    PAYMENT_ADD_CASH_DESCRIPTION: 'Add cash to complete the payment',
    // Public site
    NAV_CATALOG: 'Catalog',
    NAV_ABOUT: 'About Us',
    NAV_CONTACT: 'Contact Us',
    HOMEPAGE_TAGLINE: 'Your one-stop shop for quality stationery and office supplies.',
    HERO_BADGE: 'Trusted Stationery Store',
    SHOP_NOW: 'Shop Now',
    EXPLORE_DEALS: 'Explore Deals',
    OUR_CATEGORIES: 'Our Categories',
    OUR_BRANDS: 'Our Brands',
    ALL: 'All',
    SHOW_ALL: 'Show All',
    SHOW_LESS: 'Show Less',
    FEATURED_PRODUCTS: 'Featured Products',
    SORT_NEWEST: 'Newest',
    SORT_PRICE_LOW_HIGH: 'Price: Low to High',
    SORT_PRICE_HIGH_LOW: 'Price: High to Low',
    NO_CATEGORIES_AVAILABLE: 'No categories available right now.',
    NO_BRANDS_AVAILABLE: 'No brands available right now.',
    NO_PRODUCTS_AVAILABLE: 'No products available right now.',
    ABOUT_US_TITLE: 'About Us',
    ABOUT_US_CONTENT: 'We are a dedicated stationery store offering a wide range of quality products, from everyday office supplies to specialty stationery items. We work with trusted brands to bring you reliable products at fair prices, with a team that is always ready to help you find what you need.',
    CONTACT_US_TITLE: 'Contact Us',
    CONTACT_ADDRESS: 'Address',
    CONTACT_PHONE: 'Phone',
    CONTACT_INFO_UNAVAILABLE: 'Contact information is not available right now.',
  },
  Khmer: {
    TEST: 'សាកល្បង',
    HOME: 'ទំព័រដើម',
    OPERATION: 'ប្រតិបត្តិការ',
    FUNCTION: 'មុខងារ',
    QUEUE: 'ជួររង់ចាំ',
    SCHOOL: 'សាលា',
    ADMIN: 'អ្នកគ្រប់គ្រង',
    REPORT: 'របាយការណ៍',
    CONFIG: 'ការកំណត់',
    ATTENDANCE: 'វត្តមាន',
    CLASS: 'ថ្នាក់រៀន',
    GRADE: 'កម្រិតថ្នាក់',
    STUDENT: 'សិស្ស',
    TEACHER: 'គ្រូបង្រៀន',
    ROLE: 'តួនាទី',
    USER: 'អ្នកប្រើប្រាស់',
    CREATE: 'បង្កើត',
    REQUEST: 'សំណើ',
    UPDATE: 'កែប្រែ',
    DETAIL: 'លម្អិត',
    INFO: 'ព័ត៌មាន',
    LAYOUT: 'ប្លង់',
    SALE: 'ការលក់',
    ORGANIZE: 'ការរៀបចំ',

    // Component
    IMPORT_DATA: 'នាំចូលទិន្នន័យ',
    EXPORT_DATA: 'នាំចេញទិន្នន័យ',
    DOWNLOAD_TEMPLATE: 'ទាញយកគំរូ',
    PRODUCT: 'ផលិតផល',
    BY_NAME: 'តាមឈ្មោះ',
    BY_DATE: 'តាមកាលបរិច្ឆេទ',
    BY_PRICE: 'តាមតម្លៃ',
    BY_DESCRIPTION: 'តាមការពិពណ៌នា',
    AVAILABLE: 'មានស្រាប់',
    CANCEL: 'បោះបង់',
    SAVE: 'រក្សាទុក',
    CLEAR: 'សម្អាត',

    // Sale
    TRANSACTION: 'ប្រតិបត្តិការ',
    RESERVATION: 'ការកក់',
    STOCK: 'ស្តុក',
    PROMOTION: 'ប្រម៉ូសិន',
    BANNER: 'បដា',
    ORDER: 'លំដាប់',
    TOTAL_TRANSACTION: 'ប្រតិបត្តិការសរុប',
    TOTAL_RESERVATION: 'ការកក់សរុប',
    TOTAL_STOCK: 'ស្តុកសរុប',
    TOTAL_PROMOTION: 'ប្រម៉ូសិនសរុប',
    TOTAL_BANNER: 'បដាសរុប',
    CASHING: 'ការទូទាត់',

    // Function
    TOTAL_QUEUE: 'ជួររង់ចាំសរុប',

    // Organize
    CATEGORY: 'ប្រភេទ',
    BRAND: 'ម៉ាក',
    STORE: 'ហាង',
    FLOOR: 'ជាន់',
    TOTAL_CATEGORY: 'ប្រភេទសរុប',
    TOTAL_BRAND: 'ម៉ាកសរុប',
    TOTAL_PRODUCT: 'ផលិតផលសរុប',
    TOTAL_STRUCTURE: 'រចនាសម្ព័ន្ធសរុប',
    TOTAL_FLOOR: 'ជាន់សរុប',

    // Invoice Form
    PRICE: 'តម្លៃ',
    QTY: 'ចំនួន',
    ONLY: 'តែប៉ុណ្ណោះ',
    DISC: 'បញ្ចុះ',
    TOTAL: 'សរុប',
    SUBTOTAL: 'សរុបរង',
    DISCOUNT: 'បញ្ចុះតម្លៃ',
    TAX: 'ពន្ធ',
    VOUCHER: 'ប័ណ្ណ',
    PAYMENT: 'ការទូទាត់',
    LOAN_PAYMENT: 'ការទូទាត់កម្ចី',
    PROCEED: 'បន្ត',
    COMPLETED: 'បានបញ្ចប់',
    GENERAL: 'ទូទៅ',
    START_NOW: 'ចាប់ផ្តើមឥឡូវនេះ',

    // Table
    DESCRIPTION: 'ការពិពណ៌នា',
    START_AT: 'ថ្ងៃចាប់ផ្តើម',
    EXPIRE_AT: 'ថ្ងៃផុតកំណត់',
    STATUS: 'ស្ថានភាព',
    ITEM: 'ធាតុ',
    ACTION: 'សកម្មភាព',
    QUANTITY: 'បរិមាណ',
    ICON: 'រូបតំណាង',
    NAME: 'ឈ្មោះ',
    CREATED_BY: 'បង្កើតដោយ',
    CREATED_AT: 'ថ្ងៃបង្កើត',
    USERNAME: 'ឈ្មោះអ្នកប្រើ',
    EMAIL: 'អ៊ីមែល',
    COST: 'ថ្លៃដើម',
    CURRENCY: 'រូបិយប័ណ្ណ',
    REMAIN: 'នៅសល់',

    // Admin
    TOTAL_ROLE: 'តួនាទីសរុប',
    TOTAL_USER: 'អ្នកប្រើសរុប',
    TOTAL_PRIVILEGE: 'សិទ្ធិសរុប',
    INCOME: 'ចំណូល',
    PROFIT: 'ប្រាក់ចំណេញ',
    CHART: 'គំនូសតាង',

    // Report
    STAFF: 'បុគ្គលិក',
    SCHOOL_REPORT: 'របាយការណ៍សាលា',
    ATTENDANCE_REPORT: 'របាយការណ៍វត្តមាន',
    SALE_REPORT: 'របាយការណ៍លក់',
    PRODUCT_REPORT: 'របាយការណ៍ផលិតផល',
    STAFF_REPORT: 'របាយការណ៍បុគ្គលិក',
    INCOME_CHART: 'គំនូសតាងចំណូល',
    PERFORMANCE_CHART: 'គំនូសតាងប្រសិទ្ធភាព',
    PRODUCT_CHART: 'គំនូសតាងផលិតផល',
    TOP_PRODUCT: 'ផលិតផលពេញនិយម',

    // Product Form
    COLOR: 'ពណ៌',
    ADD_TO_CART: 'បន្ថែមទៅកន្ត្រក',
    ADD_TO_QUEUE: 'បន្ថែមទៅជួររង់ចាំ',
    ADDED_TO_QUEUE: 'បានបន្ថែមទៅជួររង់ចាំ',
    ADD_PROPERTY: 'បន្ថែមលក្ខណៈ',
    CLONE_PROPERTY: 'ចំលង\u00a0លក្ខណៈ',

    // Drawer Form
    UNIT: 'ឯកតា',
    DRAWER: 'ហិបប្រាក់',
    BUY_RATE: 'អត្រាទិញ',
    SELL_RATE: 'អត្រាលក់',
    STOP: 'បញ្ឈប់',
    START: 'ចាប់ផ្តើម',
    CASH: 'សាច់ប្រាក់',

    // Payment Form
    RECEIVE_TOTAL: 'ទទួលសរុប',
    RETURN: 'ប្រាក់អាប់',
    PRINT: 'បោះពុម្ព',
    CHECKOUT: 'ទូទាត់',
    CLOSE: 'បិទ',
    APPROVE: 'អនុម័ត',
    APPROVE_ALL: 'អនុម័តទាំងអស់',
    TRANSFER: 'ផ្ទេរ',
    SELL: 'លក់',
    BUY: 'ទិញ',

    // Homepage
    HOMEPAGE_TITLE: 'សូមស្វាគមន៍មកកាន់ហាងសម្ភារៈការិយាល័យរបស់យើង',
    WELCOME_TO: 'សូមស្វាគមន៍មកកាន់',

    // Form
    LOGIN: 'ចូលគណនី',
    REGISTER: 'ចុះឈ្មោះ',
    FROM: 'ពី',
    TO: 'ដល់',
    NOTE: 'ចំណាំ',
    STRUCTURE: 'រចនាសម្ព័ន្ធ',
    SIZE: 'ទំហំ',
    CUSTOMER: 'អតិថិជន',
    ADD: 'បន្ថែម',
    DISPLAY_NAME: 'ឈ្មោះបង្ហាញ',
    FULL_NAME: 'ឈ្មោះពេញ',
    CONTACT: 'ទំនាក់ទំនង',
    DATE_OF_BIRTH: 'ថ្ងៃខែឆ្នាំកំណើត',
    PROFILE: 'រូបភាព',
    ADDRESS: 'អាសយដ្ឋាន',
    EDIT: 'កែសម្រួល',
    DELETE: 'លុប',
    PRIVILEGE: 'សិទ្ធិ',
    LOGOUT: 'ចាកចេញ',
    ATTACHMENT: 'ឯកសារភ្ជាប់',
    VIEW_ATTACHMENT: 'មើលឯកសារភ្ជាប់',
    INTEREST: 'ការប្រាក់',
    PENALTY: 'ពិន័យ',
    DEPOSIT: 'ប្រាក់កក់',
    DURATION: 'រយៈពេល',
    LOAN_DURATION: 'រយៈពេលកម្ចី',
    APPLY_RATE: 'អត្រាការប្រាក់',
    DUE_DATE: 'ថ្ងៃកំណត់',
    PRINCIPAL_AMOUNT: 'ប្រាក់ដើម',
    PRINCIPAL_BALANCE: 'សមតុល្យប្រាក់ដើម',
    INTEREST_AMOUNT: 'ចំនួនការប្រាក់',
    TOTAL_AMOUNT: 'ចំនួនសរុប',
    INSTALMENT_DURATION: 'រយៈពេលរំលស់',
    CHANGE_PASSWORD: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់',
    OVERDUE: 'ហួសកំណត់',
    PREPAYMENT: 'ការបង់មុន',
    PREPAYMENT_PENALTY: 'ពិន័យបង់មុន',
    PREPAYMENT_DURATION: 'រយៈពេលបង់មុន',
    OVERDUE_DURATION: 'រយៈពេលហួស',
    OVERDUE_PENALTY: 'ពិន័យហួសកំណត់',
    SEARCH: 'ស្វែងរក',
    CONFIRM: 'បញ្ជាក់',
    SETUP: 'ដំឡើង',
    CALL: 'ហៅ',
    COMPLETE: 'រួចរាល់',

    // Message
    TYPE_TO_SEARCH: 'វាយដើម្បីស្វែងរក...',
    CONFIRM_DELETE: 'តើអ្នកពិតជាចង់លុបមែនទេ?',
    CONFIRM_DELETE_CUSTOMER: 'តើអ្នកពិតជាចង់លុបអតិថិជននេះមែនទេ?',
    DESCRIPTION_DELETE: 'បន្ទាប់ពីបន្ត អ្នកនឹងមិនអាចឃើញធាតុនេះទៀតទេ!',
    DESCRIPTION_DELETE_CUSTOMER:
      'នឹងលុបអតិថិជន និងទិន្នន័យទាំងអស់។',
    NO_TRANSACTION: 'គ្មានប្រតិបត្តិការ',
    NO_OPTIONS: 'គ្មានជម្រើស',
    EXPIRE_IN: 'ផុតកំណត់ក្នុង',
    EXPIRED: 'បានផុតកំណត់',
    TRIAL: 'សាកល្បង',
    day: 'ថ្ងៃ',
    PAGE_NOT_FOUND: 'រកមិនឃើញទំព័រ',
    PAGE_NOT_FOUND_DESCRIPTION:
      'មិនអាចរកឃើញទំព័រដែលបានស្នើនៅលើម៉ាស៊ីនមេ។',
    NO_PERMISSION: 'អ្នកមិនមានសិទ្ធិចូលប្រើទំព័រនេះទេ។',
    NO_PERMISSION_DESCRIPTION: 'សូមទៅកាន់',

    // Status
    VACANT: 'ទំនេរ',
    OCCUPIED: 'កំពុងប្រើ',
    RESERVED: 'បានកក់',
    LOAN: 'កម្ចី',

    // Config
    SENT_AFTER_PAYMENT: 'ផ្ញើបន្ទាប់ពីទូទាត់',
    SENT_AFTER_OPEN_DRAWER: 'ផ្ញើបន្ទាប់ពីបើកហិបប្រាក់',
    SENT_AFTER_CLOSE_DRAWER: 'ផ្ញើបន្ទាប់ពីបិទហិបប្រាក់',
    REQUEST_LOAN: 'ស្នើសុំកម្ចី',

    // Loan Detail
    TOTAL_LOAN: 'កម្ចីសរុប',
    TOTAL_PAID: 'បានបង់សរុប',
    TOTAL_REMAIN: 'នៅសល់សរុប',
    TOTAL_PENALTY: 'ពិន័យសរុប',
    DEPOSIT_LOAN: 'ដាក់ប្រាក់កម្ចី',
    GRAND_TOTAL: 'សរុបទាំងអស់',
    IN_PROGRESS: 'កំពុងដំណើរការ',
    CLEARED: 'បានសងរួច',
    APPROVED: 'បានអនុម័ត',
    REJECTED: 'បានបដិសេធ',
    PENDING: 'កំពុងរង់ចាំ',
    PRINCIPLE_AMOUNT: 'ចំនួនប្រាក់ដើម',
    PAY_OFF: 'សងផ្តាច់',
    PAID_OFF: 'បានសងផ្តាច់',
    TERMINATE: 'បញ្ចប់',
    WRITE_OFF: 'លុបបំណុល',
    WRITE_OFF_LOAN: 'លុបកម្ចី',
    WRITTEN_OFF: 'បានលុបបំណុល',
    IN_REVIEW: 'កំពុងពិនិត្យ',
    PREVIEW: 'មើលជាមុន',
    LOAN_AMOUNT: 'ចំនួនកម្ចី',
    PHONE_NUMBER: 'លេខទូរស័ព្ទ',
    SELECT_CUSTOMER: 'ជ្រើសរើសអតិថិជន',
    ADD_CUSTOMER: 'បន្ថែមអតិថិជន',
    NO_CUSTOMER_DESCRIPTION:
      'រកមិនឃើញអតិថិជន។ ចុចខាងក្រោមដើម្បីបន្ថែមថ្មី។',
    RECEIPT: 'បង្កាន់ដៃ',
    CLEAR_PAYMENT: 'លុបការទូទាត់',
    CLEAR_PAYMENT_WARNING:
      'សកម្មភាពនេះនឹងលុបទិន្នន័យទូទាត់ទាំងអស់ជាអចិន្ត្រៃយ៍ក្នុងចន្លោះកាលបរិច្ឆេទដែលបានកំណត់។ សូមប្រាកដថាអ្នកបានបម្រុងទុកទិន្នន័យចាំបាច់មុនពេលបន្ត។',
    WARNING: 'ការព្រមាន',
    BACKUP: 'បម្រុងទុក',
    THERMAL_PRINTING: 'ការបោះពុម្ពស្លាក',
    PRINT_LABEL: 'បោះពុម្ពស្លាក',
    PRINT_RECEIPT: 'បោះពុម្ពបង្កាន់ដៃ',
    GROUP_PAYMENT: 'ការទូទាត់ជាក្រុម',
    TABLE: 'តុ',
    TYPE: 'ប្រភេទ',
    PAYMENT_ADD_CASH: 'បន្ថែមសាច់ប្រាក់',
    PAYMENT_ADD_CASH_DESCRIPTION: 'បន្ថែមសាច់ប្រាក់ដើម្បីបញ្ចប់ការទូទាត់',
    // Public site
    NAV_CATALOG: 'ផលិតផល',
    NAV_ABOUT: 'អំពីយើង',
    NAV_CONTACT: 'ទាក់ទងយើង',
    HOMEPAGE_TAGLINE: 'គ្រប់តម្រូវការសម្ភារៈការិយាល័យ និងសម្ភារៈសិក្សារបស់អ្នក នៅកន្លែងតែមួយ។',
    HERO_BADGE: 'ហាងសម្ភារៈការិយាល័យដែលអាចទុកចិត្តបាន',
    SHOP_NOW: 'ទិញឥឡូវនេះ',
    EXPLORE_DEALS: 'មើលការបញ្ចុះតម្លៃ',
    OUR_CATEGORIES: 'ប្រភេទផលិតផល',
    OUR_BRANDS: 'ម៉ាកយីហោរបស់យើង',
    ALL: 'ទាំងអស់',
    SHOW_ALL: 'មើលទាំងអស់',
    SHOW_LESS: 'មើលតិចជាងនេះ',
    FEATURED_PRODUCTS: 'ផលិតផលពិសេស',
    SORT_NEWEST: 'ថ្មីបំផុត',
    SORT_PRICE_LOW_HIGH: 'តម្លៃទាបទៅខ្ពស់',
    SORT_PRICE_HIGH_LOW: 'តម្លៃខ្ពស់ទៅទាប',
    NO_CATEGORIES_AVAILABLE: 'មិនទាន់មានប្រភេទផលិតផលនៅឡើយទេ។',
    NO_BRANDS_AVAILABLE: 'មិនទាន់មានម៉ាកយីហោនៅឡើយទេ។',
    NO_PRODUCTS_AVAILABLE: 'មិនទាន់មានផលិតផលនៅឡើយទេ។',
    ABOUT_US_TITLE: 'អំពីយើង',
    ABOUT_US_CONTENT:
      'យើងជាហាងលក់សម្ភារៈការិយាល័យ និងសម្ភារៈសិក្សា ដែលផ្តល់ជូននូវផលិតផលគុណភាពជាច្រើនប្រភេទ គិតចាប់ពីសម្ភារៈប្រើប្រាស់ប្រចាំថ្ងៃ រហូតដល់ផលិតផលពិសេស។ យើងសហការជាមួយម៉ាកយីហោដែលទុកចិត្តបាន ដើម្បីនាំមកជូនអ្នកនូវផលិតផលដែលអាចទុកចិត្តបាន និងតម្លៃសមរម្យ ជាមួយក្រុមការងារដែលរួចរាល់ជួយអ្នករកមើលអ្វីដែលអ្នកត្រូវការ។',
    CONTACT_US_TITLE: 'ទាក់ទងយើង',
    CONTACT_ADDRESS: 'អាសយដ្ឋាន',
    CONTACT_PHONE: 'លេខទូរស័ព្ទ',
    CONTACT_INFO_UNAVAILABLE: 'មិនទាន់មានព័ត៌មានទំនាក់ទំនងនៅឡើយទេ។',
  }
}